import {
  PanelContainer,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React, {useEffect, useState} from 'react';

import Checkbox from 'components/Checkbox';

export interface LeaderBoardPreferencesProps {
  status: boolean;
  onSetStatus: () => void;
}

const LeaderBoardPreferences = (props: LeaderBoardPreferencesProps) => {
  const {status, onSetStatus} = props;
  const isDesktop = useIsDesktop();
  const [isChecked, setIsChecked] = useState(status);

  const onCheckboxPress = (checked: boolean) => {
    onSetStatus();
    setIsChecked(checked);
  };

  useEffect(() => {
    setIsChecked(status);
  }, [status]);

  return (
    <PanelContainer
      defaultOpen={false}
      panelTitle="PUBLIC LEADERBOARD"
      icon="award">
      <Text
        mb="32px"
        fontSize={isDesktop ? 4 : 3}
        lineHeight={isDesktop ? '26px' : '24px'}>
        Check below if you want your name displayed on the Public Leaderboard
        via on-site kiosks. {'\n'}
      </Text>

      <View flexDirection="row" mb="32px">
        <View mt={2}>
          {status !== undefined && (
            <Checkbox
              accessibilityLabel="Display name on public leaderboard"
              isChecked={isChecked}
              value="leaderboard"
              onChange={onCheckboxPress}
            />
          )}
        </View>
        <View minW={6} />
        <Text
          flexShrink={1}
          fontSize={isDesktop ? 4 : 3}
          lineHeight={isDesktop ? '26px' : '24px'}>
          Display my name on the Public Leaderboard via on-site kiosks. By
          checking this box, I also certify that I am aware my name may still be
          displayed via other public-facing leaderboards.
        </Text>
      </View>
      <Text
        fontFamily="body"
        fontSize={isDesktop ? '12px' : '11px'}
        lineHeight={isDesktop ? '20px' : '18px'}>
        <Text bold fontSize={isDesktop ? '12px' : '11px'}>
          Please note:
        </Text>{' '}
        Even if you choose to opt out of the on-site kiosk displays, your name
        may still be displayed via other public-facing leaderboards.
      </Text>
    </PanelContainer>
  );
};

export default LeaderBoardPreferences;
